import { useEffect, useState } from "react";
import api from "@/lib/api";
import { stayCities } from "@/lib/worldDestinations";

// The stays Toukky lists itself (partners and its catalogue); without a city
// the search asks no supplier, so this is the inventory a traveller can open.
const INVENTORY_LIMIT = 60;

/**
 * The cities Toukky lists stays in, with how many and a photo of one of them
 * (lib/worldDestinations stayCities). Empty while loading, when the list
 * cannot be read, or when `enabled` is false (the caller already has them).
 * A full page (INVENTORY_LIMIT stays) may not be the whole inventory: the
 * cities come without a count then, rather than a number that is too low.
 */
export default function useStayCities({ enabled = true } = {}) {
  const [cities, setCities] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    api.get("/hotels", { params: { limit: INVENTORY_LIMIT } })
      .then((r) => {
        const rows = Array.isArray(r.data) ? r.data : [];
        if (active) setCities(stayCities(rows, { counted: rows.length < INVENTORY_LIMIT }));
      })
      .catch(() => { if (active) setCities([]); });
    return () => { active = false; };
  }, [enabled]);
  return cities;
}
